/**
 * The two element builders the pad's markup is written with.
 *
 * Apart from `handwriting-markup.ts` so that the dialog is the arrangement and
 * this is the making of one element. The candidate button is here too, being
 * the other thing this file knows how to make.
 */

/** Makes one element with a class, and text where it has any. */
export function element<K extends keyof HTMLElementTagNameMap>(
  page: Document,
  tag: K,
  className: string,
  text?: string,
): HTMLElementTagNameMap[K] {
  const made = page.createElement(tag);

  made.className = className;

  if (text !== undefined) {
    made.textContent = text;
  }

  return made;
}

/** Makes one of the buttons under the square. */
export function action(
  page: Document,
  className: string,
  text: string,
): HTMLButtonElement {
  const button = element(page, "button", className, text);

  button.type = "button";

  return button;
}

/** One candidate, as the button a reader presses to take it. */
export function candidateButton(
  page: Document,
  character: string,
): HTMLButtonElement {
  const button = action(page, "cb-handwriting-candidate", character);

  button.lang = "zh";
  button.setAttribute("aria-label", `Add ${character}`);

  return button;
}
